/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Filter_ReturnInputs */



/**
* | output |
* | --- |
* | "Return air filter" |
*
* @param {Air_Handler_Unit_Filter_ReturnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_filter_return = /** @type {((inputs?: Air_Handler_Unit_Filter_ReturnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Filter_ReturnInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air filter")
	return /** @type {LocalizedString} */ ("Filtre d'air repris")
});